<modal-layout [modalTitle]="data.title">
    <div modalBody>
        <carousel class="default-swiper swiper-slide-per-view"
                  [slidesPerView]="'auto'"
                  [style.--pc-slides-ceil]="pcSlidesCeil"
                  [style.--pc-slides]="pcSlides"
                  [style.--pc-gutter]="pcGutter"
                  [freeMode]="true"
                  imageViewRoot>
            @for(product of data.products; track product.id){
            <ng-template swiperSlide>
                <product [model]="product"></product>
            </ng-template>
            }
        </carousel>
    </div>
</modal-layout>